import { createAsyncAction, FULFILLED, PENDING, REJECTED } from '../utils'
import { selectTeam } from '../selectors/teamSelectors'
import { getLookerUrlApi } from '../../services/team'

export const TEAM_REPORT_URL_GET = 'foodsby/teamReport/TEAM_REPORT_URL_GET'

export const getTeamReportUrl = createAsyncAction(TEAM_REPORT_URL_GET)

export const getTeamReportUrlStart = () => {
  return (dispatch, getState) => {
    const state = getState()
    const team = selectTeam(state)
    return dispatch(getTeamReportUrl(getLookerUrlApi(team.id)))
  }
}

const ACTION_HANDLERS = {
  [FULFILLED(TEAM_REPORT_URL_GET)]: (state, action) => {
    return {
      ...state,
      reportUrl: action.payload.url,
      isLoadingUrl: false,
    }
  },
  [PENDING(TEAM_REPORT_URL_GET)]: state => {
    return {
      ...state,
      reportUrl: '',
      isLoadingUrl: true,
    }
  },
  [REJECTED(TEAM_REPORT_URL_GET)]: (state, action) => {
    return {
      ...state,
      reportUrl: '',
      isLoadingUrl: false,
      error: action.payload,
    }
  },
}

export const initialState = {
  hasReportAccess: false,
  isLoadingAccess: false,
  reportUrl: '',
  isLoadingUrl: false,
  error: null,
}

export default function teamReport(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}
